import { MessageSquare } from "lucide-react";

export default function WhatsAppButton({ enabled, number }) {
  if (!enabled || !number) return null;
  const digits = String(number).replace(/\D/g, "");
  if (!digits) return null;
  const url = `https://wa.me/${digits}?text=${encodeURIComponent(
    "Hi Five Peaks! I'd like more info about your services.",
  )}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-launcher"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-20 left-5 z-50 bg-[#25D366] hover:bg-[#1FB855] text-white w-14 h-14 rounded-full grid place-items-center elev-3 transition-transform hover:scale-105"
    >
      <svg viewBox="0 0 24 24" className="w-7 h-7" fill="currentColor" aria-hidden="true">
        <path d="M19.05 4.91A10 10 0 0 0 12.04 2C6.55 2 2.07 6.48 2.07 11.97c0 1.76.46 3.48 1.34 5L2 22l5.21-1.36a10 10 0 0 0 4.83 1.23h.01c5.49 0 9.97-4.48 9.97-9.97a9.9 9.9 0 0 0-2.97-7.09Zm-7.01 15.34h-.01a8.3 8.3 0 0 1-4.23-1.16l-.3-.18-3.09.81.83-3.01-.2-.31a8.27 8.27 0 0 1-1.27-4.42c0-4.57 3.72-8.29 8.29-8.29 2.21 0 4.29.86 5.85 2.43a8.21 8.21 0 0 1 2.42 5.86c0 4.57-3.72 8.27-8.29 8.27Zm4.55-6.2c-.25-.13-1.47-.72-1.7-.81-.23-.08-.39-.13-.56.13-.16.25-.64.81-.79.97-.14.16-.29.18-.54.06-.25-.13-1.05-.39-2-1.23-.74-.66-1.24-1.48-1.39-1.73-.14-.25-.02-.39.11-.51.11-.11.25-.29.37-.43.13-.14.16-.25.25-.41.08-.16.04-.31-.02-.44-.06-.13-.56-1.34-.77-1.84-.2-.49-.41-.42-.56-.43h-.48c-.16 0-.43.06-.66.31s-.86.84-.86 2.05c0 1.21.88 2.38 1 2.55.13.16 1.74 2.66 4.21 3.73.59.25 1.05.41 1.41.52.59.19 1.13.16 1.55.1.47-.07 1.47-.6 1.68-1.18.21-.58.21-1.07.14-1.18-.06-.11-.22-.18-.46-.31Z" />
      </svg>
    </a>
  );
}
